import React, { Component } from 'react';
import { AccentColor } from 'helpers/AccentColorHelper';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from '@material-ui/core/Button';

import AddExtraApplicantsForm from './AddExtraApplicantsForm';

export default withMobileDialog()(
  class extends Component {
    render() {
      return (
        <Dialog
          disableBackdropClick
          fullScreen={this.props.fullScreen}
          open={this.props.dialogOpen}
          onClose={this.props.toggleDialog}
          classes={{
            paper: 'form-dialog',
          }}
        >
          <DialogTitle>
            <h3 style={{ textAlign: 'center', margin: 0 }}>Add/Edit Applicant(s)</h3>
          </DialogTitle>
          <DialogContent>
            <AddExtraApplicantsForm initialValues={{ applicants: this.props.applicants }} />
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.props.toggleDialog}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              CANCEL
            </FlatButton>
          </DialogActions>
        </Dialog>
      );
    }
  }
);
